import React, { useState, useEffect } from "react";
import { Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks";
import { getWebARAnalytics } from "../../../../redux/actions";
import { fetchError } from "../../../../redux/actions";
import { BarChart } from "./components/BarChart";

interface AnalyticData {
    date: string,
    view_ar: number,
    unique_view_ar: number,
}

const Analytics = () => {

    const businessGroupState = useAppSelector(state => state.businessGroup);
    const dispatch = useAppDispatch();

    const [analyticData, setAnalyticData] = useState<AnalyticData[]>();

    const [chartData, setChartData] = useState({
        labels: [] as string[], 
        datasets: [
            {
                label: "Visits",
                data: [] as number[],
                backgroundColor: "#e60049" 
            },
            {
                label: "Unique Users",
                data: [] as number[],
                backgroundColor: "#0bb4ff"
            }
        ],
    });


    useEffect(() => {
        getAnalyticData();
    }, [businessGroupState.currentBusinessGroup]);

    useEffect(() => {
        if (analyticData) {
            setChartData({
                labels: analyticData.map((data) => data.date),
                datasets: [
                    {
                        label: "Visits",
                        data: analyticData.map((data) => data.view_ar),
                        backgroundColor: "#e60049"
                    },
                    {
                        label: "Unique Users",
                        data: analyticData.map((data) => data.unique_view_ar),
                        backgroundColor: "#0bb4ff"
                    }
                ]
            });
        }
    }, [analyticData]);

    const getAnalyticData = () => {
        const group_id = businessGroupState.currentBusinessGroup!.id;
        dispatch(
            getWebARAnalytics(group_id,(analytics) => {
            if (analytics) {
                setAnalyticData(analytics);
            }
            else {
                dispatch(fetchError("Failed to recieve analytic data"));
            } 
        }));
    };

    return (
        <Box sx={{ width: "100%", justifyContent: "center", maxHeight: "calc(100vh - 300px)", overflowY: "auto" }}>
            <BarChart chartData={chartData} />
            <TableContainer component={Paper} sx={{ backgroundColor: "white", maxWidth: 500 }}>
                <Table aria-label="analytics table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Visits</TableCell>
                            <TableCell>Unique Users</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {analyticData?.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell component="th" scope="row">
                                    {row.date}
                                </TableCell>
                                <TableCell>{row.view_ar}</TableCell>
                                <TableCell>{row.unique_view_ar}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );

};

export default Analytics;